export default "__VITE_ASSET__1Dz5sBAb__"